import * as React from "react";
import type { SVGProps } from "react";
const Computer2PanelIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm5.85 1a.65.65 0 0 1 .65-.65h3a.65.65 0 1 1 0 1.3h-3A.65.65 0 0 1 9.85 6M4 17.725a.775.775 0 0 0 0 1.55h16a.775.775 0 0 0 0-1.55z" clipRule="evenodd" /></svg>;
export default Computer2PanelIcon;